module.exports = __webpack_public_path__ + "img/hero.3e586477.jpg";